import { UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps, UIComponentImpl } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ListToneViewImpl } from './listtoneview';
import { ListToneCSSStyleImpl } from './listtonecss';
import { ListTonesViewModelImpl } from './viewmodel/listtoneviewmodel';

import { ToneDto } from '../../../../core/dto/tonedto';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { ListTonesDto } from '../../../../core/dto/listtones/listtonesdto';
import { ListToneAPIModelImpl, ListToneAPIModel } from './listtoneapimodel';
import { AlertType } from '../../../toolkit/alert/alerttype';

import { ChildListTonesDto} from 'src/com/sixdee/crbtportal/core/dto/listtones/childlisttonesdto';
import { ShuffleDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/shuffle/shufflesdto';



export interface ListTonesComponentProps extends UIComponentProps
{
    // isShuffleOn:boolean;
    isShuffleOn(isEnabled:boolean): void;
}
export interface ListTonesComponentState extends UIComponentState{
    shuffleStatus:boolean;

}

export interface ListTonesComponentHandler extends UIComponentHandler
{
    isShuffleOn(isEnabled:boolean): void;
    showShuffleActivatePopup():void;
    showShuffleDeActivatePopup():void;
    
}

export class ListTonesComponent extends UIComponentImpl<ListTonesComponentProps,
ListTonesComponentState, UIDataModel> implements ListTonesComponentHandler
{
    private listTonesViewModel: ListTonesViewModelImpl;

    constructor(props: ListTonesComponentProps, state:ListTonesComponentState)
    {
        super(props);
          
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.state = {shuffleStatus:false};
        
        this.listTonesViewModel = new ListTonesViewModelImpl(props.context, this.onDeleteClicked);
    }

    componentDidMount()
    {
        (this.getAPIModel() as ListToneAPIModel).getListofCurrentlyPlaylingTunes();
      
    }
    showShuffleActivatePopup():void
    {
        (this.getView() as ListToneViewImpl).closePopup();
        (this.getView() as ListToneViewImpl).showLoader(); 
        (this.getAPIModel() as ListToneAPIModel).shuffleActivateAndDeactivate("activate");
    }
    showShuffleDeActivatePopup():void
    {
        (this.getView() as ListToneViewImpl).closePopup();
        (this.getView() as ListToneViewImpl).showLoader(); 
        (this.getAPIModel() as ListToneAPIModel).shuffleActivateAndDeactivate("deactivate");
    }
    isShuffleOn(isEnabled:boolean): any 
    {
       

        if(isEnabled)
        {
            (this.getView() as ListToneViewImpl).showShuffleSuccessActivatePopup();
        }
        else 
        {
            (this.getView() as ListToneViewImpl).showShuffleSuccessDeActivatePopup();  
        }
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ListToneViewImpl(this.listTonesViewModel, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ListToneCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ListToneAPIModelImpl(applicationContext, apiModelHandler);
    }

    // componentWillReceiveProps()
    // {
    //     this.forceUpdateComponent();
    // }

    setLoadMoreData(playingMytunes : ListTonesDto[])
    {
        this.listTonesViewModel.setListDatas(playingMytunes);
        

        this.forceUpdateComponent();
    }

    onDeleteClicked(toneDto : ListTonesDto): void
    {
        (this.getView() as ListToneViewImpl).dismissLoader(); 
            if(this.listTonesViewModel.getListOfDatas().length === 1 )
            {
                (this.getView() as ListToneViewImpl).showPopup("","You should have at-least one tune in your currently playing list.",AlertType.ERROR);
            }
            else{
                (this.getView() as ListToneViewImpl).showLoader(); 
                (this.getAPIModel() as ListToneAPIModel).deleteTone(toneDto);
            }
      
    }
    updateStatus(listToneDto: ListTonesDto[])
    {
        
       listToneDto.forEach((toneDto: ListTonesDto)=>
        {
           
          console.log("----------swan"+toneDto.getServiceName());
            if(toneDto.getServiceName() === "AllCaller" && toneDto.getIsShuffle() === "T")
          {
              console.log("shuffle flag");
            this.setState({shuffleStatus:true});

            this.props.isShuffleOn(true);
          }
          
         
        });
        // (this.profileTunes as TunesListTabViewModelImpl).updateTabData(listToneDto.filter((toneDto: ToneDto)=>
        // {
        //     return (toneDto as ListTonesDto).getIsStatusRBT();
        // }));
    }
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
      
        if(feature === APIFeatures.LIST_TONES)
        {   
          
            this.updateStatus(data as ListTonesDto[]);
            (this.getView() as ListToneViewImpl).dismissLoader(); 

            this.listTonesViewModel.getListOfDatas().length = 0;
            data.filter((toneDto: ToneDto)=>
            {
               
              let dto = (toneDto as ChildListTonesDto);
              console.log("----------swan"+dto.getServiceName());
              
             
            });
            this.listTonesViewModel.setListDatas(data as ListTonesDto[]);
         
            this.forceUpdateComponent();
         
            
           
        }
        else if (feature === APIFeatures.SHUFFLE)
        {
            if((data as ShuffleDtoImpl).getIdentifier() === "activate")
            {
                this.props.isShuffleOn(true);
            }
            else
            {
                this.props.isShuffleOn(false);
            }
            (this.getAPIModel() as ListToneAPIModel).getListofCurrentlyPlaylingTunes();
        }
        else
        {
            
            (this.getView() as ListToneViewImpl).showLoader(); 
            (this.getAPIModel() as ListToneAPIModel).getListofCurrentlyPlaylingTunes();
            
           

            //pop
            // (this.getView() as ListToneViewImpl).showPopup((data as ToneDto).getId(), "Your Order completed successfully.",AlertType.SUCCESS);
           
        }

        window.scroll(0, 0);
    }

    refreshList():void{
        (this.getView() as ListToneViewImpl).showLoader(); 
        (this.getAPIModel() as ListToneAPIModel).getListofCurrentlyPlaylingTunes();

    }
    onFailure(feature: APIFeatures, description: string, data: any): void
    {
        if(feature === APIFeatures.DELETE_FROM_SHUFFLE ||feature === APIFeatures.DELETE_DEDICATION )
        {
            (this.getView() as ListToneViewImpl).dismissLoader(); 
            (this.getView() as ListToneViewImpl).showPopup("",description,AlertType.ERROR);
        }
        else if(feature === APIFeatures.SHUFFLE)
        {
            (this.getView() as ListToneViewImpl).dismissLoader(); 
          
            if((data as ShuffleDtoImpl).getIdentifier() === "activate")
            {
                this.props.isShuffleOn(false);
            }
            else
            {
                this.props.isShuffleOn(true);
            }
            (this.getView() as ListToneViewImpl).showShuffleFailurePopup("",description,AlertType.ERROR);


        }
        window.scroll(0, 0);
    }

    addTuneToList(toneDto: ToneDto)
    {
        // this.listTonesViewModel.getListOfDatas().push(toneDto as ListTonesDto);

        // this.forceUpdateComponent();
        //(this.getAPIModel() as ListToneAPIModel).getListofCurrentlyPlaylingTunes();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/listtonecomponent.tsx